const CONTROL_BUCKET = 'control';
const EXPERIMENT_BUCKET = 'experiment';
const TREATMENT_BUCKET = 'treatment';
const VARIANT_BUCKET = 'variant';
const FORCED = 'forced';
const IDENTIFIER_BCID = 'BrowserCookieId';
const IDENTIFIER_USERID = 'UserId';
const IDENTIFIER_VIN = 'VIN';
const BLOCKING = true;

export {
  CONTROL_BUCKET,
  EXPERIMENT_BUCKET,
  TREATMENT_BUCKET,
  VARIANT_BUCKET,
  FORCED,
  IDENTIFIER_BCID,
  IDENTIFIER_USERID,
  IDENTIFIER_VIN,
  BLOCKING // Use when experiment component should block rendering with a Spinner until bucket is assigned
};
